import { useTranslation } from 'react-i18next';
import { allocationService } from '../services/allocationService';
import type { AllocationFilters, ScopedExportRequest } from '../types/Filters';
import type { AllocationColumn } from './useAllocationColumns';
import { useSpreadsheetExport } from './useSpreadsheetExport';

/** Filtros, ordenação e colunas da tabela valem nos dois escopos; `page` leva também a página e o tamanho dela. */
export function useExportAllocations(
  { page, perPage, ...filters }: AllocationFilters,
  columns: readonly AllocationColumn[],
) {
  const { t } = useTranslation('alocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ scope, ...options }) =>
      allocationService.exportSpreadsheet(
        scope === 'page' ? { ...filters, page, perPage } : filters,
        { ...options, columns },
      ),
    t('exportacao.nomeArquivo'),
  );
}
